module.exports = __webpack_public_path__ + "img/pricing_card_marker.afdcc0eb.svg";